import { useEffect, useMemo, useState } from 'react'

import { api, toggle } from 'utils'
import { AUTORI, LISTINGSEARCH, VALORIATTRIBUTO } from 'utils/endpoint'

import AutoreCard from 'components/card/AutoreCard'
import SlickSlider from 'react-slick'
import DropdownAlgolia from 'components/atomic/DropdownAlgolia'

const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'

const settings = {
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 5,
  variableWidth: true,
  autoplay: false,
  arrows: false,
  centerPadding: '15px',
}

function ListingAutori({ filtriInitial = [] }) {
  const [ordini, setOrdini] = useState([])
  const [ordine, setOrdine] = useState(null)
  const [lettera, setLettera] = useState('A')
  const [lettere, setLettere] = useState([])
  const [tassonomia, setTassonomia] = useState(null)

  const [autori, setAutori] = useState([])

  function handleChangeOrdine(ordine) {
    if (ordine) setOrdine(ordine)
  }

  async function initOrdini() {
    const response = await api.get(LISTINGSEARCH)
    const { ordini_scuola } = await response.data

    const ordini = ordini_scuola.map(o => ({ value: o.id, label: o.nome }))

    if (ordini.length) {
      const ordine = ordini.find(o => filtriInitial.includes(o.value))
      setOrdine(ordine || ordini[2])
    }
    setOrdini(ordini)
  }

  async function initTassonomia() {
    const response = await api.get(`${VALORIATTRIBUTO}${filtriInitial[0]}/`)
    const tassonomia = await response.data
    setTassonomia(tassonomia)
  }

  useEffect(() => {
    initOrdini()
    if (filtriInitial.length) initTassonomia()
  }, [])

  useEffect(() => {
    if (ordine) searchAutori()
  }, [lettera, ordine])

  useEffect(() => {
    if (!autori.length && lettere.length && lettere[0] !== lettera) setLettera(lettere[0]) // passo alla prima lettera con autori se non ce ne sono con la corrente
  }, [lettere, autori])

  async function searchAutori() {
    let filtriId = filtriInitial
    if (ordine)
      filtriId = filtriId.filter(f => !ordini.map(o => o.value).includes(f)).concat([ordine.value])

    const params = {
      redazionale: true,
      attributi__valore_attributo_id__exact: filtriId.join(','),
      lettera,
    }

    const { data } = await api.get(`${AUTORI}listing/`, { params })
    const { lettere_disponibili, autori } = data

    setLettere(lettere_disponibili)
    setAutori(autori)
  }

  const paginationDesktop = useMemo(
    () =>
      alphabet.split('').map(l => (
        <span
          className={`pagination__item ${lettere.includes(l) ? '' : 'pagination__nav--disabled'} ${
            l === lettera ? 'pagination__item--active' : ''
          }`}
          onClick={() => setLettera(l)}
          key={l}
        >
          {l}
        </span>
      )),
    [lettere, lettera]
  )

  const paginationMobile = useMemo(
    () =>
      alphabet.split('').map(l => (
        <div key={l}>
          <span
            className={`pagination__item ${
              lettere.includes(l) ? '' : 'pagination__nav--disabled'
            } ${l === lettera ? 'pagination__item--active' : ''}`}
            onClick={() => setLettera(l)}
          >
            {l}
          </span>
        </div>
      )),
    [lettere, lettera]
  )

  return (
    <div className="listing-autori">
      <p className="listing-autori__tassonomia">
        {tassonomia && ordine && tassonomia.nome !== ordine.label
          ? `per "${tassonomia.nome?.toLowerCase()}"`
          : ''}
        {ordine ? ` per ${ordine.label?.toLowerCase()}` : ''}
      </p>
      <div className="listing-autori__top">
        <div>
          <p className="listing-autori__help">Trova gli autori in ordine alfabetico</p>
          <div className="pagination pagination--desktop">{paginationDesktop}</div>
          <div className="pagination pagination--mobile">
            <SlickSlider {...settings}>{paginationMobile}</SlickSlider>
          </div>
        </div>
        <div>
          <p className="listing-autori__help">Filtra per ordine di scuola</p>
          <div className="listing-autori__ordine">
            <DropdownAlgolia
              instanceId={'ordini'}
              placeholder={ordine?.label}
              options={ordini}
              onChange={handleChangeOrdine}
            />
          </div>
        </div>
      </div>
      <p className="listing-autori__stats">
        {autori.length} {autori.length === 1 ? 'autore' : 'autori'} con la {lettera}
      </p>
      <div className="listing-autori__listing">
        {autori.map(a => (
          <AutoreCard autore={a} key={a.id} />
        ))}
      </div>
    </div>
  )
}

export default ListingAutori
